<template>

<van-tabs v-model="active" @click="tabOnClick" swipeable  sticky  background="#b37536" title-inactive-color="#6b3c16" title-active-color="#6b3c16"	>
  <notice-bar
          bg-color="red"
          scrollable="true"
          color="red"
          mode="closeable"
          :text="userOrderIndexVo.rollNotice" 
          v-if="userOrderIndexVo.rollNotice"/>
  <van-tab v-for="(item,index) in typeList" :title="item.cateName" :key="index">

  <div :class="[posterImageStatus ? 'noscroll product-con' : 'product-con']" v-if="item.code=='qifu'">
    <product-con-swiper
      :img-urls="storeInfo.sliderImageArr"
    ></product-con-swiper>
    
    <div class="wrapper">
      <div class="share acea-row row-between row-bottom">
        <div class="introduce">祈福类型：</div>
        <!-- <div class="iconfont icon-fenxiang" @click="listenerActionSheet"></div> -->
      </div>
    </div>
    <div >
      <div style="background:#FFFFFF;">
        <table border="0" width="100%" style="text-align: center;font-weight:545;border-collapse:separate; border-spacing:0px 10px;">
            <tr>
              <td>
                    <table @click="selectQiFu('imgUrl_quanjiafu1')">
                        <tr><td><img v-bind:src="qifuType.imgUrl_quanjiafu1" class="image"/></td></tr>
                        <tr><td :class="[qifuType.lampSelectClass1 ? 'lampSelect' : '']">{{qifuType.font_quanjiafu1}}</td></tr>
                    </table>
                </td>
                <td>
                    <table  @click="selectQiFu('imgUrl_quanjiafu2')">
                        <tr><td><img v-bind:src="qifuType.imgUrl_quanjiafu2" class="image"/></td></tr>
                        <tr><td :class="[qifuType.lampSelectClass2 ? 'lampSelect' : '']">{{qifuType.font_quanjiafu2}}</td></tr>
                    </table>
                </td>
                <td>
                    <table  @click="selectQiFu('imgUrl_quanjiafu3')">
                        <tr><td><img v-bind:src="qifuType.imgUrl_quanjiafu3" class="image"/></td></tr>
                        <tr><td :class="[qifuType.lampSelectClass3 ? 'lampSelect' : '']">{{qifuType.font_quanjiafu3}}</td></tr>
                    </table>
                </td>
                <td>
                    <table  @click="selectQiFu('imgUrl_quanjiafu4')">
                        <tr><td><img v-bind:src="qifuType.imgUrl_quanjiafu4" class="image"/></td></tr>
                        <tr><td :class="[qifuType.lampSelectClass4 ? 'lampSelect' : '']">{{qifuType.font_quanjiafu4}}</td></tr>
                    </table>
                </td>
                <td>
                    <table  @click="selectQiFu('imgUrl_quanjiafu5')">
                        <tr><td><img v-bind:src="qifuType.imgUrl_quanjiafu5" class="image"/></td></tr>
                        <tr><td :class="[qifuType.lampSelectClass5 ? 'lampSelect' : '']">{{qifuType.font_quanjiafu5}}</td></tr>
                    </table>
                </td>
            </tr>
            <tr>
                <td>
                    <table  @click="selectQiFu('imgUrl_quanjiafu6')">
                        <tr><td><img v-bind:src="qifuType.imgUrl_quanjiafu6" class="image"/></td></tr>
                        <tr><td :class="[qifuType.lampSelectClass6 ? 'lampSelect' : '']">{{qifuType.font_quanjiafu6}}</td></tr>
                    </table>
                </td>
                <td>
                    <table  @click="selectQiFu('imgUrl_quanjiafu7')">
                        <tr><td><img v-bind:src="qifuType.imgUrl_quanjiafu7" class="image"/></td></tr>
                        <tr><td :class="[qifuType.lampSelectClass7 ? 'lampSelect' : '']">{{qifuType.font_quanjiafu7}}</td></tr>
                    </table>
                </td>
                <td>
                    <table  @click="selectQiFu('imgUrl_quanjiafu8')">
                        <tr><td><img v-bind:src="qifuType.imgUrl_quanjiafu8" class="image"/></td></tr>
                        <tr><td :class="[qifuType.lampSelectClass8 ? 'lampSelect' : '']">{{qifuType.font_quanjiafu8}}</td></tr>
                    </table>
                </td>
                <td>
                    <table  @click="selectQiFu('imgUrl_quanjiafu9')">
                        <tr><td><img v-bind:src="qifuType.imgUrl_quanjiafu9" class="image"/></td></tr>
                        <tr><td :class="[qifuType.lampSelectClass9 ? 'lampSelect' : '']">{{qifuType.font_quanjiafu9}}</td></tr>
                    </table>
                </td>
                <td>
                    <table  @click="selectQiFu('imgUrl_quanjiafu10')">
                        <tr><td><img v-bind:src="qifuType.imgUrl_quanjiafu10" class="image"/></td></tr>
                        <tr><td :class="[qifuType.lampSelectClass10 ? 'lampSelect' : '']">{{qifuType.font_quanjiafu10}}</td></tr>
                    </table>
                </td>
            </tr>
            <tr>
                <td>
                    <table  @click="selectQiFu('imgUrl_quanjiafu11')">
                        <tr><td><img v-bind:src="qifuType.imgUrl_quanjiafu11" class="image"/></td></tr>
                        <tr><td :class="[qifuType.lampSelectClass11 ? 'lampSelect' : '']">{{qifuType.font_quanjiafu11}}</td></tr>
                    </table>
                </td>
                <td>
                    <table  @click="selectQiFu('imgUrl_quanjiafu12')">
                        <tr><td><img v-bind:src="qifuType.imgUrl_quanjiafu12" class="image"/></td></tr>
                        <tr><td :class="[qifuType.lampSelectClass12 ? 'lampSelect' : '']">{{qifuType.font_quanjiafu12}}</td></tr>
                    </table>
                </td>
                <td>
                    <table  @click="selectQiFu('imgUrl_quanjiafu13')">
                        <tr><td><img v-bind:src="qifuType.imgUrl_quanjiafu13" class="image"/></td></tr>
                        <tr><td :class="[qifuType.lampSelectClass13 ? 'lampSelect' : '']">{{qifuType.font_quanjiafu13}}</td></tr>
                    </table>
                </td>
                <td>
                    <table  @click="selectQiFu('imgUrl_quanjiafu14')">
                        <tr><td><img v-bind:src="qifuType.imgUrl_quanjiafu14" class="image"/></td></tr>
                        <tr><td :class="[qifuType.lampSelectClass14 ? 'lampSelect' : '']">{{qifuType.font_quanjiafu14}}</td></tr>
                    </table>
                </td>
                <td>
                    <table  @click="selectQiFu('imgUrl_quanjiafu15')">
                        <tr><td><img v-bind:src="qifuType.imgUrl_quanjiafu15" class="image"/></td></tr>
                        <tr><td :class="[qifuType.lampSelectClass15 ? 'lampSelect' : '']">{{qifuType.font_quanjiafu15}}</td></tr>
                    </table>
                </td>
            </tr>
        </table> 
      </div>
    </div>
    <div class="product-window on">
        <div class="productWinList">
          <div
            class="item"
            v-for="(item, indexw) in attr.productAttr"
            :key="indexw"
          >
            <div class="title">{{ item.attrName }}</div>
            <div class="listn acea-row row-middle">
              <div
                class="itemn"
                v-for="(itemn, indexn) in item.attrValue"
                :class="itemn.attr == attrValue ? 'on' : ''"
                @click="tapAttr(indexw, indexn)"
                :key="indexn"
              >
                {{ itemn.attr }}
              </div>
            </div>
          </div>
        </div>
    </div>
    <!-- <div class="product-intro">
      <div class="title">简介</div>
      <div class="conter" v-html="storeInfo.description"></div>
    </div> -->
    <div style="height:1.2rem;"></div>
    <div class="footer acea-row row-between-wrapper">
      <div class="bnt acea-row">
        <div class="buy" @click="tapBuy">立即随喜</div>
      </div>
    </div>
    <!-- <CouponPop v-on:changeFun="changeFun" :coupon="coupon"></CouponPop> -->
    <!-- <Product-window v-on:changeFun="changeFun" :attr="attr"></Product-window> -->
    <!-- <StorePoster
      v-on:setPosterImageStatus="setPosterImageStatus"
      :posterImageStatus="posterImageStatus"
      :posterData="posterData"
    ></StorePoster>
    <ShareInfo
      v-on:setShareInfoStatus="setShareInfoStatus"
      :shareInfoStatus="shareInfoStatus"
    ></ShareInfo> -->
    <!-- <div
      class="generate-posters acea-row row-middle"
      :class="posters ? 'on' : ''"
    >
      <div class="item" v-if="weixinStatus === true" @click="setShareInfoStatus">
        <div class="iconfont icon-weixin3"></div>
        <div class="">发送给朋友</div>
      </div>
      <div class="item" @click="setPosterImageStatus">
        <div class="iconfont icon-haibao"></div>
        <div class="">生成海报</div>
      </div>
    </div> -->
    <!-- <div
      class="mask"
      @touchmove.prevent
      @click="listenerActionClose"
      v-show="posters"
    ></div> -->
    <!-- <div class="geoPage" v-if="mapShow">
      <iframe
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="no"
        :src="
          'https://apis.map.qq.com/uri/v1/geocoder?coord=' +
            system_store.latitude +
            ',' +
            system_store.longitude +
            '&referer=' +
            mapKey
        "
      >
      </iframe>
    </div> -->
    <!-- <div v-if="locationShow && !isWeixin">
      <iframe
        ref="geoPage"
        width="0"
        height="0"
        style="display:none;"
        frameborder="0"
        scrolling="no"
        :src="
          'https://apis.map.qq.com/tools/geolocation?key=' +
            mapKey +
            '&referer=h5'
        "
      >
      </iframe>
    </div> -->
  </div>


  <div :class="[posterImageStatus ? 'noscroll product-con' : 'product-con']" v-if="item.code=='jianjie'">
    <product-con-swiper
      :img-urls="storeInfo.sliderImageArr"
    ></product-con-swiper>
    <div class="product-intro">
      <div class="title">简介</div>
      <div class="conter" style="background-color:#ffffff" v-html="storeInfo.description"></div>
    </div>
    <div style="height:1.2rem;"></div>
  </div>

  <div class="my-account" v-if="item.code=='gongdebang'">
    <div class="wrapper" style="background-color:#a35608">
      <div class="header">
        <div class="headerCon">
          <div style="font-size:0.4rem;text-align:center;margin:0,auto;color:#6b3c16">功德榜</div>
          <div style="height:0.3rem;"></div>
          <table style="width:95%;margin:auto;border-radius:0.16rem;overflow:hidden" border="0">
            <tr style="background-color:#6f4419;height:1.5rem" v-for="(item, index) in userOrderIndexVo.userOrderMeritsCountVo" :key="index" >
                <td style="text-align:left;padding:0 0 0rem 0.2rem;width:3.1rem;font-size:0.27rem;">
                  
                  <img v-bind:src="item.avatar" style="width:1rem;border-radius:1rem;vertical-align:middle"/>
                  &nbsp;{{item.nickname}}
                </td>
                <td style="text-align:center;font-size:0.27rem;">{{item.totalPrice}}</td>
                <td style="text-align:center;font-size:0.27rem;">第{{index+1}}名</td>
            </tr>
           
          </table>
        </div>
      </div>
      <div class="advert acea-row row-between-wrapper"></div>
    </div>
  </div>
  <!-- </pull-refresh> -->
  </van-tab>
</van-tabs>

</template>
<style>
.van-tab {
  font-size: 0.3rem;
  /* font-weight:bold; */
}
</style>
<style scoped>
.activity_pin {
  width: auto;
  height: 0.44rem;
  background: linear-gradient(
    90deg,
    rgba(233, 51, 35, 1) 0%,
    rgba(250, 101, 20, 1) 100%
  );
  opacity: 1;
  border-radius: 0.22rem;
  padding: 0 0.2rem;
  margin-left: 0.19rem;
}
.activity_miao {
  width: auto;
  height: 0.44rem;
  padding: 0 0.2rem;
  background: linear-gradient(
    90deg,
    rgba(250, 102, 24, 1) 0%,
    rgba(254, 161, 15, 1) 100%
  );
  opacity: 1;
  border-radius: 0.22rem;
  margin-left: 0.19rem;
}
.iconfonts {
  color: #fff !important;
  font-size: 0.28rem;
  display: block;
}
.activity_title {
  font-size: 0.24rem;
  color: #fff;
}
.activity_kan {
  width: auto;
  height: 0.44rem;
  padding: 0 0.2rem;
  background: linear-gradient(
    90deg,
    rgba(254, 159, 15, 1) 0%,
    rgba(254, 178, 15, 1) 100%
  );
  opacity: 1;
  border-radius: 0.22rem;
  margin-left: 0.19rem;
}
.addressBox .phone {
  margin-left: 1.1rem;
}
.corlor-yshop {
  color: #eb3729;
}
.store-box {
  padding: 0 0.3rem;
  border-bottom: 1px solid #f5f5f5;
}
.geoPage {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 10000;
}
.product-con .store-info {
  margin-top: 0.2rem;
  background-color: #fff;
}
.product-con .store-info .title {
  padding: 0 0.3rem;
  font-size: 0.28rem;
  color: #282828;
  height: 0.8rem;
  line-height: 0.8rem;
  border-bottom: 0.01rem solid #f5f5f5;
}
.product-con .store-info .info {
  padding: 0 0.3rem;
  height: 1.26rem;
}
.store-info .icon-jiantou {
  color: #7a7a7a;
  font-size: 0.28rem;
}
.product-con .store-info .info .pictrue {
  width: 0.76rem;
  height: 0.76rem;
}
.product-con .store-info .info .pictrue img {
  width: 100%;
  height: 100%;
  border-radius: 0.06rem;
}
.product-con .store-info .info .text {
  width: 56%;
}
.product-con .store-info .info .text .name {
  font-size: 0.3rem;
  color: #282828;
}
.product-con .store-info .info .text .address {
  font-size: 0.24rem;
  color: #666;
  margin-top: 0.03rem;
}
.product-con .store-info .info .text .address .iconfont {
  color: #707070;
  font-size: 0.18rem;
  margin-left: 0.1rem;
}
.address_tit {
  max-width: 88% !important;
}
.addressTxt {
  width: auto;
  font-size: 0.24rem;
}
.product-con .store-info .info .iconfont {
  font-size: 0.4rem;
}
.product-con .superior {
  background-color: #fff;
  margin-top: 0.2rem;
}
.product-con .superior .title {
  height: 0.98rem;
}
.product-con .superior .title img {
  width: 0.3rem;
  height: 0.3rem;
}

.product-con .superior .slider-banner .list .item {
  width: 2.15rem;
  margin: 0 0.22rem 0.3rem 0;
  font-size: 0.26rem;
}
.product-con .superior .slider-banner .list .item:nth-of-type(3n) {
  margin-right: 0;
}
.product-con .superior .slider-banner .list .item .pictrue {
  width: 100%;
  height: 2.15rem;
}
.product-con .superior .slider-banner .list .item .pictrue img {
  width: 100%;
  height: 100%;
  border-radius: 0.06rem;
}
.product-con .superior .slider-banner .list .item .name {
  color: #282828;
  margin-top: 0.12rem;
}
.product-con .superior .slider-banner .swiper-pagination-bullet {
  background-color: #999;
}
.product-con .superior .slider-banner .swiper-pagination-bullet-active {
  background-color: #e93323;
}

.mask {
  -webkit-filter: blur(2px);
  -moz-filter: blur(2px);
  -ms-filter: blur(2px);
  filter: blur(2px);
}
.footer .icon-shoucang1 {
  color: #eb3729;
}
.product-con .product-intro .conter div {
  width: 100% !important;
}
.generate-posters {
  width: 100%;
  height: 1.7rem;
  background-color: #fff;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 99;
  transform: translate3d(0, 100%, 0);
  -webkit-transform: translate3d(0, 100%, 0);
  -ms-transform: translate3d(0, 100%, 0);
  -moz-transform: translate3d(0, 100%, 0);
  -o-transform: translate3d(0, 100%, 0);
  transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -webkit-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -moz-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -o-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
}
.generate-posters.on {
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0);
}
.generate-posters .item {
  flex: 50%;
  -webkit-flex: 50%;
  -ms-flex: 50%;
  text-align: center;
}
.generate-posters .item .iconfont {
  font-size: 0.8rem;
  color: #5eae72;
}
.generate-posters .item .iconfont.icon-haibao {
  color: #5391f1;
}
.noscroll {
  height: 100%;
  overflow: hidden;
}
</style>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import ProductConSwiper from "@components/ProductConSwiper";
import UserEvaluation from "@components/UserEvaluation";
import CouponPop from "@components/CouponPop";
import ProductWindow from "@components/ProductWindow";
import StorePoster from "@components/StorePoster";
import ShareInfo from "@components/ShareInfo";
import debounce from "lodash.debounce";
import lazhu from '@assets/images/lazhu1.png'
import lazhuSelect from '@assets/images/lazhu3.png'
import { PullRefresh, NoticeBar, Toast } from "vant";
import { meritsList } from "@api/lamp";

import {
  getProductDetail,
  postCartAdd,
  getCartCount,
  getProductPoster
} from "@api/store";
import {
  getCoupon,
  getCollectAdd,
  getCollectDel,
  getUserInfo
} from "@api/user";
import { isWeixin } from "@utils/index";
import { wechatEvevt, wxShowLocation } from "@libs/wechat";
import { mapGetters } from "vuex";
import cookie from "@utils/store/cookie";

const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
const MAPKEY = "mapKey";

export default {
  name: "GoodsCon",
  components: {
    PullRefresh,
    NoticeBar,
    swiper,
    swiperSlide,
    ProductConSwiper,
    UserEvaluation,
    CouponPop,
    ProductWindow,
    StorePoster,
    ShareInfo
  },
  data: function() {
    return {
      // activeName: '功德榜',
      userOrderIndexVo:{},
      // meritsList:[],
      // typeList: [{cateName:'祈福供灯',code:'qifu'},{cateName:'寺院简介',code:'jianjie'},{cateName:'功德榜',code:'gongdebang'},{cateName:'个人中心'}],
      typeList: [{cateName:'祈福供灯',code:'qifu'}],
      qifuType: {
        qifubaoSelect:"",
        lampSelectClass1:false,
        lampSelectClass2:false,
        lampSelectClass3:false,
        lampSelectClass4:false,
        lampSelectClass5:false,
        lampSelectClass6:false,
        lampSelectClass7:false,
        lampSelectClass8:false,
        lampSelectClass9:false,
        lampSelectClass10:false,
        lampSelectClass11:false,
        lampSelectClass12:false,
        lampSelectClass13:false,
        lampSelectClass14:false,
        lampSelectClass15:false,


        imgUrl_quanjiafu1:lazhu,
        font_quanjiafu1:"全家福灯",

        imgUrl_quanjiafu2:lazhu,
        font_quanjiafu2:"平安健康",

        imgUrl_quanjiafu3:lazhu,
        font_quanjiafu3:"事业兴旺",

        imgUrl_quanjiafu4:lazhu,
        font_quanjiafu4:"消灾免难",

        imgUrl_quanjiafu5:lazhu,
        font_quanjiafu5:"国泰民安",

        imgUrl_quanjiafu6:lazhu,
        font_quanjiafu6:"财运亨通",

        imgUrl_quanjiafu7:lazhu,
        font_quanjiafu7:"赐福添寿",

        imgUrl_quanjiafu8:lazhu,
        font_quanjiafu8:"福慧增长",

        imgUrl_quanjiafu9:lazhu,
        font_quanjiafu9:"婚姻美满",

        imgUrl_quanjiafu10:lazhu,
        font_quanjiafu10:"心想事成",

        imgUrl_quanjiafu11:lazhu,
        font_quanjiafu11:"诸事圆满",

        imgUrl_quanjiafu12:lazhu,
        font_quanjiafu12:"求子祈福",

        imgUrl_quanjiafu13:lazhu,
        font_quanjiafu13:"学业有成",

        imgUrl_quanjiafu14:lazhu,
        font_quanjiafu14:"还愿祈福",

        imgUrl_quanjiafu15:lazhu,
        font_quanjiafu15:"光明灯"
      },
      
      storeSales:0,
      locationShow: false,
      shareInfoStatus: false,
      weixinStatus: false,
      mapShow: false,
      mapKey: "",
      posterData: {
        codeBase: "",
        title: "",
        price: "",
        code: ""
      },
      posterImageStatus: false,
      animated: false,
      coupon: {
        coupon: false,
        list: []
      },
      attr: {
        cartAttr: false,
        productAttr: [],
        productSelect: {}
      },
      isOpen: false, //是否打开属性组件
      productValue: [],
      id: 0,
      storeInfo: {},
      couponList: [],
      attrTxt: "请选择",
      attrValue: "",
      cart_num: 1, //购买数量
      replyCount: "",
      replyChance: "",
      reply: [],
      priceName: 0,
      CartCount: 0,
      posters: false,
      banner: [{}, {}],
      swiperRecommend: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: false,
        loop: false,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      system_store: {},
      tempName: "全国包邮"
    };
  },
  computed: mapGetters(["isLogin"]),
  mounted: function() {
    this.id = this.$route.params.id;
    this.getSelectQiFu("imgUrl_quanjiafu1");
    this.getMeritsList();
    this.productCon();
    // this.coupons();
    
  },
  methods: {
  //   beforeChange(index) {
  //     // 返回 false 表示阻止此次切换
  //     // if (index === 1) {
  //     //   return false;
  //     // }

  //     // 返回 Promise 来执行异步逻辑
  //     return new Promise((resolve) => {
  //       // 在 resolve 函数中返回 true 或 false
  //       // resolve(index !== 3);
  //         //   this.$store.dispatch("USERINFO").then((res) => {
  //         //       if(0==res.level){
  //         //           this.$router.push({path: '/user/vip'});
  //         //           resolve(false)
  //         //       }else{
  //         //           resolve(true)
  //         //       }
  //         // });
  //     });
     
  // },
  tabOnClick: debounce(function(name, title) {
      if(name==null||name==""){
          name=0;
      }
      if(name==3){
          this.$router.push({path: '/user'});
      }
    }, 300),

    tapAttr: function(indexw, indexn) {
      let that = this;
      that.attr.productAttr[indexw].index = indexn;
      let value = that
        .getCheckedValue()
        .sort()
        .join(",");
      that.$emit("changeFun", { action: "ChangeAttr", value: value });
    },
    //获取被选中属性；
    getCheckedValue: function() {
      let productAttr = this.attr.productAttr;
      console.log("=============="+productAttr)
      let value = [];
      for (let i = 0; i < productAttr.length; i++) {
        for (let j = 0; j < productAttr[i].attrValueArr.length; j++) {
          if (productAttr[i].index === j) {
            value.push(productAttr[i].attrValueArr[j]);
            this.attrValue=productAttr[i].attrValueArr[j];
          }
        }
      }
      return value;
    },

    getStoreList() {
      this.$store.commit("GET_TO", "details");
      this.$router.push("/shop/storeList/details");
    },
    getWXLocation() {
      if (isWeixin()) {
        let _this = this;
        wechatEvevt("getLocation", { type: "wgs84" })
          .then(res => {
            let latitude = res.latitude; // 纬度
            let longitude = res.longitude; // 经度
            cookie.set(LATITUDE, latitude);
            cookie.set(LONGITUDE, longitude);
          })
          .catch(res => {
            if (res.is_ready) {
              res.wx.getLocation({
                success(res) {
                  let latitude = res.latitude; // 纬度
                  let longitude = res.longitude; // 经度
                  cookie.set(LATITUDE, latitude);
                  cookie.set(LONGITUDE, longitude);
                },
                cancel() {
                  _this.$dialog.error("取消获取位置");
                  cookie.remove(LATITUDE);
                  cookie.remove(LONGITUDE);
                },
                fail() {
                  _this.$dialog.error("授权失败");
                  cookie.remove(LATITUDE);
                  cookie.remove(LONGITUDE);
                }
              });
            }
          });
      } else {
        if (!this.mapKey)
          return this.$dialog.error("定位失败，请配置您的腾讯地图key");
        let loc;
        // 腾讯地图监听定位组件的message事件
        console.log("aaaa:" + this.mapKey);
        if (this.mapKey) this.locationShow = true;
        window.addEventListener(
          "message",
          function(event) {
            loc = event.data; // 接收位置信息 LONGITUDE
            console.log("location", loc);
            if (loc && loc.module == "geolocation") {
              cookie.set(LATITUDE, loc.lat);
              cookie.set(LONGITUDE, loc.lng);
            } else {
              cookie.remove(LATITUDE);
              cookie.remove(LONGITUDE);
              console.log("定位失败");
            }
          },
          false
        );
      }
    },
    showMap: function() {
      if (isWeixin()) {
        let config = {
          latitude: parseFloat(this.system_store.latitude),
          longitude: parseFloat(this.system_store.longitude),
          name: this.system_store.name,
          address: this.system_store.address
        };
        wechatEvevt("openLocation", config)
          .then(res => {
            console.log(res);
          })
          .catch(res => {
            if (res.is_ready) {
              res.wx.openLocation(config);
            }
          });
      } else {
        if (!this.mapKey)
          return this.$dialog.error(
            "暂无法使用查看地图，请配置您的腾讯地图key"
          );
        this.mapShow = true;
      }
    },
    updateTitle() {
      document.title = this.storeInfo.storeName || this.$route.meta.title;
    },
    setOpenShare: function() {
      var data = this.storeInfo;
      var href = location.href;
      if (isWeixin()) {
        if (this.isLogin) {
          getUserInfo().then(res => {
            href =
              href.indexOf("?") === -1
                ? href + "?spread=" + res.data.uid
                : href + "&spread=" + res.data.uid;
            var configAppMessage = {
              desc: data.storeInfo,
              title: data.storeName,
              link: href,
              imgUrl: data.image
            };
            wechatEvevt(
              ["updateAppMessageShareData", "updateTimelineShareData"],
              configAppMessage
            )
              .then(res => {
                console.log(res);
              })
              .catch(res => {
                console.log(res);
                if (res.is_ready) {
                  res.wx.updateAppMessageShareData(configAppMessage);
                  res.wx.updateTimelineShareData(configAppMessage);
                }
              });
          });
        } else {
          var configAppMessage = {
            desc: data.storeInfo,
            title: data.storeName,
            link: href,
            imgUrl: data.image
          };
          wechatEvevt(
            ["updateAppMessageShareData", "updateTimelineShareData"],
            configAppMessage
          )
            .then(res => {
              console.log(res);
            })
            .catch(res => {
              console.log(res);
              if (res.is_ready) {
                res.wx.updateAppMessageShareData(configAppMessage);
                res.wx.updateTimelineShareData(configAppMessage);
              }
            });
        }
      }
    },
    setShareInfoStatus: function() {
      this.shareInfoStatus = !this.shareInfoStatus;
      this.posters = false;
    },
    setPosterImageStatus: function() {
      let that = this;
      let data = {
        from: "h5"
      };
      getProductPoster(that.id, data)
        .then(res => {
          that.posterData.codeBase = res.data;
        })
        .catch(res => {
          that.$dialog.error(res.msg);
          that.$router.go(-1);
        });
      var sTop = document.body || document.documentElement;
      sTop.scrollTop = 0;
      this.posterImageStatus = !this.posterImageStatus;
      this.posters = false;
    },
    //产品详情接口；
    productCon: function() {
      let that = this;
      let data = {
        latitude: cookie.get(LATITUDE) || "",
        longitude: cookie.get(LONGITUDE) || ""
      };
      //存储当前产品id
      cookie.set("productId", that.id);
      // alert(that.id)
      getProductDetail(that.id, data)
        .then(res => {

          that.$set(that, "storeInfo", res.data.storeInfo);
          that.$set(that.attr, "productAttr", res.data.productAttr);
          that.$set(that, "productValue", res.data.productValue);
          that.$set(that, "replyCount", res.data.replyCount);
          that.$set(that, "replyChance", res.data.replyChance);
          that.reply = res.data.reply ? [res.data.reply] : [];
          that.$set(that, "reply", that.reply);
          that.$set(that, "priceName", res.data.priceName);
          that.$set(that, "tempName", res.data.tempName);

          that.system_store = res.data.systemStore;
          //console.log(res.data);
          that.mapKey = res.data.mapKey;
          cookie.set(MAPKEY, res.data.mapKey);
          that.updateTitle();
          that.DefaultSelect();
          that.getCartCount();
          that.setOpenShare();
          //存储当前寺庙id
          // cookie.set("cateId", res.data.storeInfo.cateId);
          

// alert(res.data.storeInfo.cateId)
          // if (!cookie.get(LATITUDE) && !cookie.get(LONGITUDE))
          //   this.getWXLocation();
        })
        .catch(res => {
          that.$dialog.error(res.msg);                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
          that.$router.go(-1);
        });
    },
    //默认选中属性；
    DefaultSelect: function() {

      let productAttrUnique = this.$route.query.productAttrUnique;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                
      let productAttr = this.attr.productAttr;
      let value = [];
      for (let i = 0; i < productAttr.length; i++) {
        this.$set(productAttr[i], "index", 0);
        value.push(productAttr[i].attrValueArr[0]);
      }
      let sku = value.sort().join(",");

      for(let key  in this.productValue){
            console.log(key + '---' + this.productValue[key])
            if(productAttrUnique!=null&&productAttrUnique!=""){
            if(this.productValue[key].unique==productAttrUnique){
                sku = this.productValue[key].sku;
                break;
            }
        }
      }
      
      let productSelect = this.productValue[sku];
      this.attrValue=sku;
      if (productSelect && productAttr.length) {
        
          this.$set(
            this.attr.productSelect,
            "store_name",
            this.storeInfo.storeName
          );
          // console.log("productSelect======================================:" + productSelect.barCode);
          this.$set(this.attr.productSelect, "barCode", productSelect.barCode);
          this.$set(this.attr.productSelect, "image", productSelect.image);
          this.$set(this.attr.productSelect, "price", productSelect.price);
          this.$set(this.attr.productSelect, "stock", productSelect.stock);
          this.$set(this.attr.productSelect, "unique", productSelect.unique);
          this.$set(this.attr.productSelect, "cart_num", 1);
          //this.$set(this, "attrValue", value.sort().join(","));
          this.$set(this, "attrValue", sku);
          //alert(sku)
          this.$set(this, "attrTxt", "已选择");
      } 

    },
    //购物车；
    ChangeCartNum: function(changeValue) {
      //changeValue:是否 加|减
      //获取当前变动属性
      let productSelect = this.productValue[this.attrValue];
      //如果没有属性,赋值给商品默认库存
      if (productSelect === undefined && !this.attr.productAttr.length)
        productSelect = this.attr.productSelect;
      //无属性值即库存为0；不存在加减；
      if (productSelect === undefined) return;
      let stock = productSelect.stock || 0;
      let num = this.attr.productSelect;
      if (changeValue) {
        num.cart_num++;
        if (num.cart_num > stock) {
          this.$set(this.attr.productSelect, "cart_num", stock);
          this.$set(this, "cart_num", stock);
        }
      } else {
        num.cart_num--;
        if (num.cart_num < 1) {
          this.$set(this.attr.productSelect, "cart_num", 1);
          this.$set(this, "cart_num", 1);
        }
      }
    },
    //将父级向子集多次传送的函数合二为一；
    changeFun: function(opt) {
      if (typeof opt !== "object") opt = {};
      let action = opt.action || "";
      let value = opt.value === undefined ? "" : opt.value;
      this[action] && this[action](value);
    },
    //打开优惠券插件；
    couponTap: function() {
      let that = this;
      that.coupons();
      that.coupon.coupon = true;
    },
    changecoupon: function(msg) {
      this.coupon.coupon = msg;
      this.coupons();
    },
    currentcoupon: function(res) {
      let that = this;
      that.coupon.coupon = false;
      that.$set(that.coupon.list[res], "is_use", true);
    },
    //可领取优惠券接口；
    coupons: function() {
      let that = this,
        q = { page: 1, limit: 20, productId: that.id, type: 1 };
      getCoupon(q).then(res => {
        that.$set(that, "couponList", res.data || []);
        that.$set(that.coupon, "list", res.data);
      });
    },
    //打开属性插件；
    selecAttrTap: function() {
      this.attr.cartAttr = true;
      this.isOpen = true;
    },
    changeattr: function(msg) {
      this.attr.cartAttr = msg;
      this.isOpen = false;
    },
    //选择属性；
    ChangeAttr: function(res) {
      console.log(res);
      let productSelect = this.productValue[res];
      console.log(this.productValue);
      console.log(productSelect);
      if (productSelect) {
        this.$set(this.attr.productSelect, "barCode", productSelect.barCode);
        this.$set(this.attr.productSelect, "image", productSelect.image);
        this.$set(this.attr.productSelect, "price", productSelect.price);
        this.$set(this.attr.productSelect, "stock", productSelect.stock);
        this.$set(this.attr.productSelect, "unique", productSelect.unique);
        this.$set(this.attr.productSelect, "cart_num", 1);
        this.$set(this, "attrValue", res);
        this.$set(this, "attrTxt", "已选择");
      } else {
        this.$set(this.attr.productSelect, "barCode", productSelect.barCode);
        this.$set(this.attr.productSelect, "image", this.storeInfo.image);
        this.$set(this.attr.productSelect, "price", this.storeInfo.price);
        this.$set(this.attr.productSelect, "stock", 0);
        this.$set(this.attr.productSelect, "unique", "");
        this.$set(this.attr.productSelect, "cart_num", 0);
        this.$set(this, "attrValue", "");
        this.$set(this, "attrTxt", "请选择");
      }
    },
    //收藏商品
    setCollect: function() {
      let that = this,
        id = that.storeInfo.id,
        category = "product";
      if (that.storeInfo.userCollect) {
        getCollectDel(id, category).then(function() {
          that.storeInfo.userCollect = !that.storeInfo.userCollect;
        });
      } else {
        getCollectAdd(id, category).then(function() {
          that.storeInfo.userCollect = !that.storeInfo.userCollect;
        });
      }
    },
    getMeritsList(){
        let that = this;
        meritsList(that.id).then(res => {
              that.$set(that, "userOrderIndexVo", res.data);
              let appMenu=res.data.storeCategory.appMenu;
              if(appMenu){
                  var appMenuJson=eval("("+appMenu+")")
                  this.typeList=appMenuJson;
              }
        })
        .catch(res => {
            that.$dialog.error(res.msg);                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         
        });
    },
    //  点击加入购物车按钮
    joinCart: function() {
      //0=加入购物车
      this.goCat(0);
    },
    // 加入购物车；
    goCat: function(news) {
      let that = this,
      productSelect = that.productValue[this.attrValue];
      console.log("=="+this.attrValue);
      console.log("===================================="+productSelect);
      if(!this.qifuType.qifubaoSelect){
         return that.$dialog.toast({ mes: "请选择您要祈福的类型" });
      }
      let q = {
        productId: that.id,
        cartNum: 1,
        new: news,
        // uniqueId:that.attr.productSelect !== undefined? that.attr.productSelect.unique: ""
        uniqueId:productSelect.unique,   //属性唯一标识
        deliveryId:productSelect.barCode,//属性设备编号
        qifubaoSelect:this.qifuType.qifubaoSelect
      };
      postCartAdd(q)
        .then(function(res) {
          that.isOpen = false;
          that.attr.cartAttr = false;
          if (news) {
            // alert(1)
            that.$router.push({ path: "/order/submit/" + res.data.cartId });
          } else {
            that.$dialog.toast({
              mes: "添加购物车成功",
              callback: () => {
                that.getCartCount(true);
              }
            });
          }
        })
        .catch(res => {
          that.isOpen = false;
          return that.$dialog.toast({ mes: res.msg });
        });
    },
    //获取购物车数量
    getCartCount: function(isAnima) {
      let that = this;
      const isLogin = that.isLogin;
      if (isLogin) {
        getCartCount({ numType: 0 }).then(res => {
          that.CartCount = res.data.count;
          //加入购物车后重置属性
          if (isAnima) {
            that.animated = true;
            setTimeout(function() {
              that.animated = false;
            }, 500);
          }
        });
      }
    },
    //立即购买；
    tapBuy: function() {
      //  1=直接购买
      this.goCat(1);
    },
    listenerActionSheet: function() {
      if (isWeixin() === true) {
        this.weixinStatus = true;
      }
      this.posters = true;
    },
    listenerActionClose: function() {
      this.posters = false;
    },
    selectQiFu: function(qifubao) {
      this.initSelectQiFu()
      this.getSelectQiFu(qifubao)
    },
    initSelectQiFu:function(){

        this.qifuType.imgUrl_quanjiafu1=lazhu
        this.qifuType.font_quanjiafu1="全家福灯"

        this.qifuType.imgUrl_quanjiafu2=lazhu
        this.qifuType.font_quanjiafu2="平安健康"

        this.qifuType.imgUrl_quanjiafu3=lazhu
        this.qifuType.font_quanjiafu3="事业兴旺"

        this.qifuType.imgUrl_quanjiafu4=lazhu
        this.qifuType.font_quanjiafu4="消灾免难"

        this.qifuType.imgUrl_quanjiafu5=lazhu
        this.qifuType.font_quanjiafu5="国泰民安"

        this.qifuType.imgUrl_quanjiafu6=lazhu
        this.qifuType.font_quanjiafu6="财运亨通"

        this.qifuType.imgUrl_quanjiafu7=lazhu
        this.qifuType.font_quanjiafu7="赐福添寿"

        this.qifuType.imgUrl_quanjiafu8=lazhu
        this.qifuType.font_quanjiafu8="福慧增长"

        this.qifuType.imgUrl_quanjiafu9=lazhu
        this.qifuType.font_quanjiafu9="婚姻美满"

        this.qifuType.imgUrl_quanjiafu10=lazhu
        this.qifuType.font_quanjiafu10="心想事成"

        this.qifuType.imgUrl_quanjiafu11=lazhu
        this.qifuType.font_quanjiafu11="诸事圆满"

        this.qifuType.imgUrl_quanjiafu12=lazhu
        this.qifuType.font_quanjiafu12="求子祈福"

        this.qifuType.imgUrl_quanjiafu13=lazhu
        this.qifuType.font_quanjiafu13="学业有成"

        this.qifuType.imgUrl_quanjiafu14=lazhu
        this.qifuType.font_quanjiafu14="还愿祈福"

        this.qifuType.imgUrl_quanjiafu15=lazhu
        this.qifuType.font_quanjiafu15="光明灯"

        this.qifuType.lampSelectClass1=false
        this.qifuType.lampSelectClass2=false
        this.qifuType.lampSelectClass3=false
        this.qifuType.lampSelectClass4=false
        this.qifuType.lampSelectClass5=false
        this.qifuType.lampSelectClass6=false
        this.qifuType.lampSelectClass7=false
        this.qifuType.lampSelectClass8=false
        this.qifuType.lampSelectClass9=false
        this.qifuType.lampSelectClass10=false
        this.qifuType.lampSelectClass11=false
        this.qifuType.lampSelectClass12=false
        this.qifuType.lampSelectClass13=false
        this.qifuType.lampSelectClass14=false
        this.qifuType.lampSelectClass15=false
    },

    getSelectQiFu:function(qifubaoType){
        if("imgUrl_quanjiafu1"==qifubaoType){
            this.qifuType.imgUrl_quanjiafu1=lazhuSelect
            this.qifuType.qifubaoSelect="全家福灯"
            this.qifuType.lampSelectClass1=true
        }
        if("imgUrl_quanjiafu2"==qifubaoType){
            this.qifuType.imgUrl_quanjiafu2=lazhuSelect
            this.qifuType.qifubaoSelect="平安健康"
            this.qifuType.lampSelectClass2=true
        }
        if("imgUrl_quanjiafu3"==qifubaoType){
            this.qifuType.imgUrl_quanjiafu3=lazhuSelect
            this.qifuType.qifubaoSelect="事业兴旺"
            this.qifuType.lampSelectClass3=true
        }
        if("imgUrl_quanjiafu4"==qifubaoType){
            this.qifuType.imgUrl_quanjiafu4=lazhuSelect
            this.qifuType.qifubaoSelect="消灾免难"
            this.qifuType.lampSelectClass4=true
        }
        if("imgUrl_quanjiafu5"==qifubaoType){
            this.qifuType.imgUrl_quanjiafu5=lazhuSelect
            this.qifuType.qifubaoSelect="国泰民安"
            this.qifuType.lampSelectClass5=true
        }
        if("imgUrl_quanjiafu6"==qifubaoType){
            this.qifuType.imgUrl_quanjiafu6=lazhuSelect
            this.qifuType.qifubaoSelect="财运亨通"
            this.qifuType.lampSelectClass6=true
        }
        if("imgUrl_quanjiafu7"==qifubaoType){
            this.qifuType.imgUrl_quanjiafu7=lazhuSelect
            this.qifuType.qifubaoSelect="赐福添寿"
            this.qifuType.lampSelectClass7=true
        }
        if("imgUrl_quanjiafu8"==qifubaoType){
            this.qifuType.imgUrl_quanjiafu8=lazhuSelect
            this.qifuType.qifubaoSelect="福慧增长"
            this.qifuType.lampSelectClass8=true
        }
        if("imgUrl_quanjiafu9"==qifubaoType){
            this.qifuType.imgUrl_quanjiafu9=lazhuSelect
            this.qifuType.qifubaoSelect="婚姻美满"
            this.qifuType.lampSelectClass9=true
        }
        if("imgUrl_quanjiafu10"==qifubaoType){
            this.qifuType.imgUrl_quanjiafu10=lazhuSelect
            this.qifuType.qifubaoSelect="心想事成"
            this.qifuType.lampSelectClass10=true
        }
        if("imgUrl_quanjiafu11"==qifubaoType){
            this.qifuType.imgUrl_quanjiafu11=lazhuSelect
            this.qifuType.qifubaoSelect="诸事圆满"
            this.qifuType.lampSelectClass11=true
        }
        if("imgUrl_quanjiafu12"==qifubaoType){
            this.qifuType.imgUrl_quanjiafu12=lazhuSelect
            this.qifuType.qifubaoSelect="求子祈福"
            this.qifuType.lampSelectClass12=true
        }
        if("imgUrl_quanjiafu13"==qifubaoType){
            this.qifuType.imgUrl_quanjiafu13=lazhuSelect
            this.qifuType.qifubaoSelect="学业有成"
            this.qifuType.lampSelectClass13=true
        }
        if("imgUrl_quanjiafu14"==qifubaoType){
            this.qifuType.imgUrl_quanjiafu14=lazhuSelect
            this.qifuType.qifubaoSelect="还愿祈福"
            this.qifuType.lampSelectClass14=true
        }
        if("imgUrl_quanjiafu15"==qifubaoType){
            this.qifuType.imgUrl_quanjiafu15=lazhuSelect
            this.qifuType.qifubaoSelect="光明灯"
            this.qifuType.lampSelectClass15=true
        }
    }



  }
};
</script>
